import { NgIf, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'NiFormChip',
  standalone: true,
  imports: [NgIf, NgClass],
  templateUrl: './ni-chip.component.html',
})

export class NiChipComponent {
  @Input() label: string = "";
  @Input() size: 'xsm' | 'small' | 'medium' | 'large' = "small";
  @Input() variant: 'primary' | 'secondary' | 'success' | 'warning' | 'info' | 'danger' | 'disabled' | 'gray' | 'blue' | 'plain' = "secondary";
  @Input() radius: 'small' | 'medium' | 'large' | 'full' = "full";
  @Input() isDot: boolean = false;
  @Input() showActionIcon: boolean = false;
  @Input() removable: boolean = false;
  @Input() disabled: boolean = false;
  @Input() removeIconColor: string = 'text-white'; // Default to white, can be overridden to 'text-red-500' or 'text-danger-500'
  @Output() onClick: EventEmitter<void> = new EventEmitter();
  @Output() onAction: EventEmitter<void> = new EventEmitter();

  sizes = {
    xsm: 'px-1 py-[1px] text-[11px] shadow-sm',
    small: 'px-2 py-0.5 text-xs shadow-sm',
    medium: 'px-2.5 py-0.5 text-sm shadow',
    large: 'px-3 py-0.5 text-base shadow-md'
  }

  radii = {
    small: 'rounded-sm',
    medium: 'rounded',
    large: 'rounded-md',
    full: 'rounded-full'
  }

  variants = {
    primary: 'bg-[#F26F24] text-white',
    secondary: 'bg-secondary-500 text-white',
    success: 'bg-[#40AB35] text-white',
    warning: 'bg-[#FFD029] text-[#737780]',
    info: 'bg-[#2E90FA] text-white',
    danger: 'bg-[#B80012] text-white', 
    disabled: 'bg-gray-300 text-gray-500', 
    gray: 'bg-[#6B7F86] text-white',
    blue: 'bg-[#124479] text-white',
    plain: 'bg-transparent text-gray-700 border border-gray-600'
  }
}